var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgButtonArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#F3FAFF",
  strokeLinecap: "round",
  d: "m2.475 9.192 6.717-6.717m0 0v4.95m0-4.95h-4.95"
})));
export { SvgButtonArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuNDc0ODcgOS4xOTI0TDkuMTkyMzkgMi40NzQ4OU05LjE5MjM5IDIuNDc0ODlWNy40MjQ2NE05LjE5MjM5IDIuNDc0ODlINC4yNDI2NCIgc3Ryb2tlPSIjRjNGQUZGIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";